import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8423zd4wa: FaireProductEntity = {
  token: "p_s8423zd4wa",
  type: "product",
  name: "Hearts Stoneware ceramic Mug 17oz / 500ml —  Limited Edition",
  brandToken: "b_5ja2cf4hvd",
  brandName: "Egg Back Home USA",
  imageUrl:
    "https://cdn.faire.com/fastly/71f8111133dbf9126611085ef9771d0d75f044ed625171e763fdbf6d60f866a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/669f2316a4915949bffce8478becb412b6e70e2fa8cce1be86fba14c617211b2.jpeg",
    "https://cdn.faire.com/fastly/89f3450e4b8bead3d77fb010c11e32d2ea91aea587e154a00ae9813fa8481f2e.jpeg",
    "https://cdn.faire.com/fastly/79488b6554aa4b0cd6c091170559b97f14d149e1dbb11f671a2b150f360c7199.jpeg",
    "https://cdn.faire.com/fastly/3f1599678e58f7aa244991104983f0cbbf64c6f9ddf1831cfe4cbb58990f2792.jpeg",
  ],
  priceDollars: 17,
  description:
    "Introducing the Cozy Hearts collection—a charming blend of warmth and elegance. Featuring a soft beige background adorned with delicate red hearts, this collection brings a touch of love to your home. Perfect for cozy gatherings or adding a sweet accent to your everyday décor, Cozy Hearts combines timeless design with a comforting, heartfelt touch.\n\nDimensions:\n\nDiameter: 3.54 in\nHeight: 4.33 in\nCapacity: 17oz / 500ml\n\nAll our pieces are:\n\n• Dishwasher and microwave safe.\n• Food safe.\n• Cadmium Free.\n• Material: Stoneware with less than 3% absorption.\n\nDue to our artisanal process, no two pieces are exactly alike, celebrating individuality. Glaze colors may vary slightly due to production techniques. Feel free to reach out for more info.\n",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:43.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
